import React, { useState, useEffect } from 'react';
import { DESKIE_API as API } from '../../config';
import "./ForgetPassword.css"
import { Link, useNavigate } from 'react-router-dom';
import { forgetPassword, forgetUpdate, singleJwtMember } from '../../api/member';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { showNotifications, TOAST_TYPE } from '../../CommonFunction/toaster';
import { singleProfile } from '../../api/settings';
import passComplete from "../../Assets/Images/icon/passComplete.svg";

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = useState<any>();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [memberInfo, setMemberInfo] = useState<any>({});
    const [togglePassword, setTogglePassword] = useState(false);
    const [toggleType, setToggleType] = useState("password");
    const [passwordMatch, setPasswordMatch] = useState(true);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [emailInsert, setEmailInsert] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [passwordChange, setPasswordChange] = useState(false);
    const [tokenBox, setTokenBox] = useState(false);

    const getSingleProfile = async () => {
        try {
            const { data } = await singleProfile();
            setProfile(data);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getSingleProfile();
    }, []);

    // forget mail send
    const emailSend = () => {
        let emailInfo = {
            "email": email
        }
        forgetPassword(emailInfo).then(() => {
            setEmailInsert(false);
            setEmailSent(true);
        }).catch((err) => {
            // showNotifications(TOAST_TYPE.error, err.message);
            console.log(err);
        })
    }
    const urlParams = new URLSearchParams(window.location.search);
    const token: any = urlParams.get('token');
    useEffect(() => {
        if (token) {
            setEmailInsert(false)
            singleJwtMember().then((data) => {
                setTokenBox(true);
                setMemberInfo(data.data.data);
            }).catch((err) => { console.log(err) });
        }
        else {
            setEmailInsert(true)
        }
    }, []);


    // password match
    const showPass = () => {
        setTogglePassword(!togglePassword)
        setToggleType("password")
    }

    const hidePass = () => {
        setTogglePassword(!togglePassword)
        setToggleType("")
    }


    const handleChangePassword = (event: any) => {
        setPassword(event.target.value);
    };

    const handleChangeConfirmPassword = (event: any) => {
        setConfirmPassword(event.target.value);
        if (event.target.value === password) {
            setPasswordMatch(true);
        } else {
            setPasswordMatch(false);
        }
    };

    const passChange = () => {
        let pass = {
            "password": confirmPassword
        }
        if (confirmPassword) {
            forgetUpdate(memberInfo.email, pass).then(() => {
                setTokenBox(false);
                setPasswordChange(true)
            }).catch((err) => { console.log(err) });
        }
    }
    return (
        <div className="auth-page" style={{ background: `linear-gradient(rgba(31, 41, 55, 0.9), rgba(31, 41, 55, 0.94)), url(${profile && `${API}/${encodeURI(profile.background)}`})` }}>
            <div className='forgot-password'>
                {emailInsert ? <div className="forgetBox">
                    <h6>Forgot Password</h6>
                    <div className="loginInput">
                        <label htmlFor="email">Email Address</label>
                        <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Enter your email address' className='form-control' />
                    </div>
                    <div className="forgetBtn d-flex justify-content-end">
                        <button type='submit' onClick={emailSend}>Next</button>
                    </div>
                </div> : ""}
                {emailSent ? <div className="forgetBox">
                    <h6 className='mb-2'>Password reset has been sent!</h6>
                    <p>Check your email to finish resetting your password</p>
                    <div className="forgetBtn d-flex justify-content-center" style={{ marginTop: '44px' }}>
                        <Link to='/'>Back to Login</Link>
                    </div>
                </div> : ""}

                {tokenBox ? <div className="forgetBox">
                    <h6>Create New Password</h6>
                    <div className="forgetMember">
                        <label>Your Email</label>
                        <p>{memberInfo.email}</p>
                    </div>
                    <div className="loginInput">
                        <label htmlFor="password">New Password</label>
                        <input
                            type={toggleType}
                            placeholder='Password'
                            value={password}
                            onChange={handleChangePassword}
                        />
                        {togglePassword ? <span onClick={() => showPass()}><FontAwesomeIcon icon={faEye as any} /> </span> : <span onClick={() => hidePass()}><FontAwesomeIcon icon={faEyeSlash as any} /></span>}
                    </div>

                    <div className="loginInput">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            type={toggleType}
                            placeholder='Confirm Password'
                            value={confirmPassword}
                            onChange={handleChangeConfirmPassword}
                        />
                        {togglePassword ? <span onClick={() => showPass()}><FontAwesomeIcon icon={faEye as any} /> </span> : <span onClick={() => hidePass()}><FontAwesomeIcon icon={faEyeSlash as any} /></span>}
                    </div>
                    <p className='passMatch'>{passwordMatch ? "" : "Password is not match!!"}</p>
                    <div className="forgetBtn d-flex justify-content-end">
                        <button type='submit' onClick={passChange}>Finish</button>
                    </div>
                </div> : ""}

                {passwordChange ? <div className="forgetBox">
                    <div className='d-flex justify-content-center mb-2'>
                        <img src={passComplete} alt="passComplete" />
                    </div>
                    <h6>Your password has been <br /> successfully changed!</h6>
                    <div className="forgetBtn d-flex justify-content-center">
                        <Link to="/" className='w-100 d-flex justify-content-center'>Back to Login</Link>
                    </div>
                </div> : ""}

            </div>
        </div>
    )
}

export default ForgetPassword